// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.quick-note,\n.quick-note:focus {\n  background-color: #f8f8f8 !important;\n  border-radius: 20px !important;\n  border: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
